import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { TransportPlannerProfileListService } from './transport-planner-profile-list.service';
import {
  TransportPlannerProfileListInitialState,
  TransportPlannerProfileListLoad,
} from './transport-planner-profile-list.actions';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../common/models';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { PlannerProfile } from '../../../../models';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type TransportPlannerProfileListStateModel = ListServerPaginationStateModel<PlannerProfile>;

const initialState: TransportPlannerProfileListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<TransportPlannerProfileListStateModel>({
  name: 'transportPlannerProfileList',
  defaults: initialState,
})
@Injectable()
export class TransportPlannerProfileListState {
  constructor(
    private materialPlannerProfileListService: TransportPlannerProfileListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: TransportPlannerProfileListStateModel): TransportPlannerProfileListStateModel {
    return state;
  }

  @Selector()
  static getItems(state: TransportPlannerProfileListStateModel): PlannerProfile[] {
    return state.items;
  }

  @Selector()
  static getLoaded(state: TransportPlannerProfileListStateModel): boolean {
    return state.loaded;
  }

  @Action(TransportPlannerProfileListLoad)
  getTransportList(
    ctx: StateContext<TransportPlannerProfileListStateModel>,
    { payload }: TransportPlannerProfileListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.materialPlannerProfileListService.getTransportPlannerProfileList(payload).pipe(
      map((materialPlannerProfileList: TransportPlannerProfileListStateModel) => {
        ctx.patchState({ ...materialPlannerProfileList, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(TransportPlannerProfileListInitialState)
  setInitialState(ctx: StateContext<TransportPlannerProfileListInitialState>): void {
    ctx.setState(initialState);
  }
}
